export function getAuthToken(): string {
  const token = localStorage.getItem('PAA_AUTH_TOKEN') || '';
  return token.replace(/^"(.*)"$/, '$1'); // Remove surrounding quotes
}